import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

@Injectable()
export class ProfileMenuEventsService {
  static nextId = 0;
  readonly _id = ProfileMenuEventsService.nextId++;
  get requestCompanyChange$(): Observable<void> {
    return this._requestCompanyChange$.asObservable();
  }
  get requestLogout$(): Observable<void> {
    return this._requestLogout$.asObservable();
  }
  get showMyProfile$(): Observable<void> {
    return this._showMyProfile$.asObservable();
  }

  private _requestCompanyChange$ = new Subject<void>();
  private _showMyProfile$ = new Subject<void>();
  private _requestLogout$ = new Subject<void>();

  requestCompanyChange(): void {
    this._requestCompanyChange$.next();
  }

  requestLogout(): void {
    this._requestLogout$.next();
  }

  showMyProfile(): void {
    this._showMyProfile$.next();
  }
}
